import { connect } from 'react-redux';
import SystemSpecs from './SystemSpecs';

import { setHorizonLengthChange, setYearSliderChange } from '../../../../../common/settings/actions';


const mapStateToProps = state => ({
    horizonLength: state.settings.horizonLength,
    resiToggle: state.tax.resiToggle,
    provider: state.utility.provider,
    projectState: state.projectaddress.projectState,
    firstName: state.contactUI.firstName,
    solarPanel: state.solar.solarPanel,
    systemNotes: state.solar.systemNotes,
    inverter: state.solar.inverter,
    includeESS: state.ess.includeESS,
    batteryType: state.ess.batteryType,
    setHorizonLengthChange,
    setYearSliderChange,
});

const combinedActions = {
    setHorizonLengthChange,
    setYearSliderChange,
};

export default connect(mapStateToProps, combinedActions)(SystemSpecs);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/index.js